var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { css, html, LitElement } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { DefaultFftSize, DefaultMaxDecibels, DefaultMinDecibels, } from "./constants.js";
import { DefaultCubeHelix } from "./palette.js";
import { SpectrumDragEvent, SpectrumTapEvent } from "./events.js";
import { DragController } from "../controls/drag-controller.js";
import { Mapping } from "../coordinates/mapping.js";
import { Zoom, DefaultZoom } from "../coordinates/zoom.js";
import { WaterfallImage } from "./waterfall-image.js";
let RrWaterfall = class RrWaterfall extends LitElement {
    static get styles() {
        return [
            css `
        #waterfall {
          width: 100%;
          height: 100%;
        }
      `,
        ];
    }
    render() {
        return html `<canvas id="waterfall"></canvas>`;
    }
    constructor() {
        super();
        this.minDecibels = DefaultMinDecibels;
        this.maxDecibels = DefaultMaxDecibels;
        this.palette = DefaultCubeHelix;
        this.fftSize = DefaultFftSize;
        this.zoom = DefaultZoom;
        this.draggable = false;
        this.image = new WaterfallImage();
        this.addEventListener("pointerdown", (e) => this.onPointerDown(e));
    }
    firstUpdated(changed) {
        super.firstUpdated(changed);
        this.dragController = new DragController(new WaterfallDragHandler(this));
    }
    updated(changed) {
        super.updated(changed);
        if (!changed.has("zoom"))
            return;
        this.redraw();
    }
    addFloatSpectrum(frequency, spectrum) {
        this.image.addFloatSpectrum(spectrum, this.minDecibels, this.maxDecibels, frequency, this.bandwidth);
        this.redraw();
    }
    redraw() {
        let ctx = this.getContext();
        if (ctx)
            this.image.draw(ctx, this.zoom);
    }
    getContext() {
        if (this.context)
            return this.context;
        if (!this.canvas)
            return;
        this.context = this.canvas.getContext("2d");
        const resizeObserver = new ResizeObserver(() => this.redraw());
        resizeObserver.observe(this.canvas);
        return this.context;
    }
    onPointerDown(e) {
        if (this.draggable)
            this.dragController?.startDragging(e);
    }
};
__decorate([
    property({ type: Number, reflect: true, attribute: "min-decibels" }),
    __metadata("design:type", Number)
], RrWaterfall.prototype, "minDecibels", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "max-decibels" }),
    __metadata("design:type", Number)
], RrWaterfall.prototype, "maxDecibels", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Object)
], RrWaterfall.prototype, "palette", void 0);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrWaterfall.prototype, "fftSize", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", typeof (_a = typeof Zoom !== "undefined" && Zoom) === "function" ? _a : Object)
], RrWaterfall.prototype, "zoom", void 0);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrWaterfall.prototype, "bandwidth", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Boolean)
], RrWaterfall.prototype, "draggable", void 0);
__decorate([
    query("#waterfall"),
    __metadata("design:type", typeof (_b = typeof HTMLCanvasElement !== "undefined" && HTMLCanvasElement) === "function" ? _b : Object)
], RrWaterfall.prototype, "canvas", void 0);
RrWaterfall = __decorate([
    customElement("rr-waterfall"),
    __metadata("design:paramtypes", [])
], RrWaterfall);
export { RrWaterfall };
class WaterfallDragHandler {
    constructor(waterfall) {
        this.waterfall = waterfall;
        this.fraction = 0;
    }
    startDrag() {
        this.fraction = 0;
        this.waterfall.dispatchEvent(new SpectrumDragEvent({
            fraction: 0,
            target: "waterfall",
            operation: "start",
        }));
    }
    drag(deltaX, _) {
        this.fraction =
            deltaX / (this.waterfall.clientWidth * this.waterfall.zoom.level);
        this.waterfall.dispatchEvent(new SpectrumDragEvent({ fraction: this.fraction, target: "waterfall" }));
    }
    finishDrag() {
        this.waterfall.dispatchEvent(new SpectrumDragEvent({
            fraction: this.fraction,
            target: "waterfall",
            operation: "finish",
        }));
    }
    cancelDrag() {
        this.waterfall.dispatchEvent(new SpectrumDragEvent({
            fraction: 0,
            target: "waterfall",
            operation: "cancel",
        }));
    }
    onClick(e) {
        const mapping = new Mapping(this.waterfall.zoom, this.waterfall.offsetWidth, this.waterfall.fftSize);
        let fraction = mapping.unzoomed(e.offsetX / this.waterfall.offsetWidth);
        this.waterfall.dispatchEvent(new SpectrumTapEvent({ fraction, target: "waterfall" }));
        e.preventDefault();
    }
}
